<section class="create-profile">
    <div class="container">
        <div class="row cps cps-7 emailVerifyBlock" *ngIf="verifyingBlock">
            <div class="col-lg-7 cp-box mx-auto">
                <p class="m-0">Verifying your new email address. Please wait.</p>
            </div>
        </div>

        <div class="row cps cps-7 emailVerifyBlock" *ngIf="errorVerifyingBlock">
            <div class="col-lg-7 cp-box mx-auto">
                <p class="m-0">This email change link is invalid or has expired.</p>
            </div>
        </div>

        <div class="row cps cps-7 emailVerifyBlock" *ngIf="successVerifyingBlock">
            <div class="col-lg-7 cp-box mx-auto">
                <p class="m-0">Your email address was changed. Please sign in using your new email address.</p>
            </div>
        </div>
    </div>
</section>
